/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.ApiResponse,
  CancelAutoBalanceTransfer: (params: vp.CancelAutoBalanceTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostCancelAutoBalanceTransfer: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldCancelAutoBalanceTransfer, setShouldCancelAutoBalanceTransfer] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.CancelAutoBalanceTransferRequest>({
    PortalUser: '',
  });
  const [response, setResponse] = useState<vp.ApiResponse>({
    Success: false,
    ErrorMessage: '',
  });

  useEffect(() => {
    if (!shouldCancelAutoBalanceTransfer) return () => {};

    const PostCancelAutoBalanceTransfer = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postCancelAutoBalanceTransfer(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldCancelAutoBalanceTransfer) void PostCancelAutoBalanceTransfer();
    setShouldCancelAutoBalanceTransfer(false);
    return () => {
      source.cancel();
    };
  }, [shouldCancelAutoBalanceTransfer]);

  return [
    response,
    (_params: vp.CancelAutoBalanceTransferRequest) => {
      setParams(_params);
      setShouldCancelAutoBalanceTransfer(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
      });
      setShouldCancelAutoBalanceTransfer(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostCancelAutoBalanceTransfer);